import {
    CandlestickSeries,
    Chart,
    ChartCanvas,
    EdgeIndicator,
    withDeviceRatio,
    withSize,
    XAxis,
    YAxis
} from "@daiver/react-financial-charts";
import { memo } from "react";
import {
    defaultChartCanvasProps,
    defaultChartEdgeIndicatorProps,
    defaultChartXAxisProps,
    defaultChartYAxisProps
} from "./liteTradeChartConstants.js";
import moment from "moment";

function LiteTradeChartCandle(props) {
    const {
        decimal = 3,
    } = props;

    return <>
        <ChartCanvas
            {...defaultChartCanvasProps}

            ratio={props.ratio}
            width={props.width}
            data={props.data}
            xScale={props.xScale}
            xAccessor={props.xAccessor}
            xExtents={props.xExtents}
            onLoadBefore={props.getHistoricalData}
            onLoadAfter={props.getFutureData}
            margin={props.margin}
        >
            <Chart id={1} yExtentsCalculator={props.yExtentsCalculator}>
                <XAxis {...defaultChartXAxisProps}
                       tickFormat={(d) => moment(d).format('HH:mm')}
                />
                <YAxis {...defaultChartYAxisProps}
                       tickFormat={d => d.toFixed(decimal)}
                />
                <CandlestickSeries
                    fill={d => (d.close > d.open ? "#14C679" : "#FF646C")}
                    wickStroke={d => (d.close > d.open ? "#14C679" : "#FF646C")}
                />
                <EdgeIndicator {...defaultChartEdgeIndicatorProps}
                               displayFormat={d => d.toFixed(decimal)}
                               yAccessor={props.yAccessor}
                               fill={d => (d.close > d.open ? "#14C679" : "#FF646C")}
                               lineStroke={d => (d.close > d.open ? "#14C679" : "#FF646C")}
                />
            </Chart>

        </ChartCanvas>

    </>
}

export default withSize({style: {minHeight: 300}})((withDeviceRatio()(memo(LiteTradeChartCandle))));
